import '~/webpack';
import '~/commons';
import {
  initSuperSidebar,
  initSuperSidebarToggle,
  initPageBreadcrumbs,
} from '~/super_sidebar/super_sidebar_bundle';

initSuperSidebar();
initSuperSidebarToggle();
initPageBreadcrumbs();
